import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 20,
    height: 20,
    background: '#F0F3F7',
    border: '1px solid rgba(34, 64, 96, .2)',
    cursor: 'pointer',
  },
  apply: {
    background: theme.custom.accept,
    borderColor: theme.custom.accept,
  },
  reject: {
    background: theme.custom.warning,
    borderColor: theme.custom.warning,
  },
  icon: {
    fontSize: '1rem',
    color: '#fff',
  },
  disabled: {
    opacity: '.3',
    cursor: 'default',
  },
}));
